import * as Api from '@/api';
import DeleteLastLinkModal from '@/components/Modals/DeleteLastLinkModal';
import { required } from 'vuelidate/lib/validators';
import { validateUrlWithUrlPath } from '@/utils/input_utils';
import { checkAndConcatNewArray } from '@/utils/_function.js';

export default {
  name: 'StatementForm',
  props: {
    isDataSaving: {
      type: Boolean
    },
    form: {
      type: Object,
      default: () => ({
        contentId: null,
        urls: [],
        rulesAgreement: false,
        dataAgreement: false,
        effectsAgreement: false
      })
    },
    tableLinkList: {
      type: Array,
      default: () => ([])
    },
    isDisabledBtn: {
      type: Boolean,
      default: false
    },
    isFromApi: {
      type: Boolean,
      default: false
    },
    currentContent: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      isMoreLinks: false,
      isMoreLinksFromApi: false,
      stamentId: null,
      linkList: null,
      // tableLinkList: [],
      islinksValid: true,
      error: {
        contentId: null,
        linkList: null,
        consent: null
      },
      selectedConsentValue: [],
      fields: [
        {
          key: 'url',
          label: 'URL'
        },
        {
          key: 'btn',
          label: ''
        }
      ],
      isErrorShow: false,
      isNotDublicated: false,
      matches: [],
      isFullFieldLinks: false,
      isLinksListEmpty: false,
      countClickSend: 0,
      contentList: checkAndConcatNewArray(this.$store.state.contentList, this.currentContent)
    };
  },
  validations() {
    if (this.stamentId) {
      return {
        form: {
          contentId: {
            required
          }
        }
      };
    }

    return {
      form: {
        contentId: {
          required
        },
        rulesAgreement: {
          checked(val) {
            return val;
          }
        },
        effectsAgreement: {
          checked(val) {
            return val;
          }
        },
        dataAgreement: {
          checked(val) {
            return val;
          }
        },
        urls: {
          required
        }
      }
    };
  },
  watch: {
    linkList(list) {
      this.isFullFieldLinks = false;
      this.isErrorShow = false;
      this.isLinksListEmpty = false;

      const links = (list || '').trim('\n')
        .split('\n')
        .filter((item) => {
          return !!item;
        });

      let errors = [];
      if (links.length) {
        errors = links.map((item) => {
          return validateUrlWithUrlPath(item);
        });

        this.matches = links.map((link, idx) => {
          return links.reduce((res, _link, _idx) => {
            if (idx !== _idx && link === _link) {
              res.push(_idx);
            }
            return res;
          }, []);
        });
      }

      if (this.matches.length) {
        this.isNotDublicated = this.matches.every((_) => !_.length);
      }

      if (errors) {
        this.islinksValid = errors.every((_) => _ === true);
      }

      this.$emit('updatingData', this.$props);
    },
    form: {
      handler: function() {
        this.$emit('updatingData', this.$props);
      },
      deep: true
    },
    urls: {
      handler: function() {
        this.$emit('updatingData', this.$props);
      },
      deep: true
    },
    isDataSaving(value) {
      if (value) {
        this.isFullFieldLinks = false;

        if (this.tableLinkList.length > 0) {
          this.form.urls = [];
          this.tableLinkList.map((item) => {
            this.form.urls.push(item.url);
          });
        }

        if (this.$v.$invalid) {
          this.$v.$touch();
          return;
        }

        if (this.linkList && this.linkList.length > 0) {
          if (!this.$v.$invalid) {
            this.countClickSend++;
          }

          if (this.countClickSend <= 1) {
            this.isFullFieldLinks = true;
            this.isErrorShow = true;
            this.isMoreLinks = false;
            this.isMoreLinksFromApi = false;
            this.$emit('resetAction');
            return;
          }
        }

        this.linkList = null;
        this.$emit('savingData');
      }
    }
  },
  async created() {
    this.stamentId = this.$route.params.id;
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: async(loading, search, vm) => {
      const param = {
        queryString: {
          page: 1,
          per_page: 100,
          fields: ['essentialName'],
          search: { 'essential_name': search.trim() }
        }
      };
      let contentList = [];

      await Api.getContentListForSelect(param)
        .then((response) => {
          if (response && response.data.length > 0) {
            response.data.map((item) => {
              contentList.push({
                essentialName: item.attributes.essentialName,
                id: item.id
              });
            });
          }

          loading(false);
        })
        .catch(() => {});
      vm.contentList = contentList;
    },
    beforeOpenModal() {
      const body = document.body;
      body.style.overflow = 'hidden';
    },
    beforeCloseModal() {
      const body = document.body;
      body.style.overflow = 'auto';
    },
    addLinks(links) {
      this.isFullFieldLinks = false;

      if (!links) {
        this.isLinksListEmpty = true;
        this.isErrorShow = true;
        return;
      }

      if (!this.islinksValid || !this.isNotDublicated) {
        this.isErrorShow = true;
        return;
      }

      const stringToArr = (links || '').trim('\n').split('\n').filter((item) => {
        return !!item;
      });

      this.isMoreLinks = false;
      this.isMoreLinksFromApi = false;

      // if (stringToArr.length > 30 && !this.isFromApi) {
      //   this.isMoreLinks = true;
      //   return;
      // }

      // if (this.isFromApi) {
      //   if (stringToArr.length > 200) {
      //     this.isMoreLinksFromApi = true;
      //     return;
      //   }
      // } else if (!this.isFromApi && stringToArr.length > 30) {
      //   this.isMoreLinks = true;
      //   return;
      // }

      const checkBeforeOutputTableList = stringToArr.concat(this.tableLinkList) || [];
      if (checkBeforeOutputTableList.length > 30 && !this.isFromApi) {
        this.isMoreLinks = true;
        this.$emit('resetAction');
        return;
      }

      if (checkBeforeOutputTableList.length > 200 && this.isFromApi) {
        this.isMoreLinksFromApi = true;
        this.$emit('resetAction');
        return;
      }

      stringToArr.map((item) => {
        this.tableLinkList.push({ url: item });
      });

      if (this.tableLinkList.length > 0) {
        this.form.urls = [];
        this.tableLinkList.map((item) => {
          this.form.urls.push(item.url);
        });
      }

      this.linkList = null;
    },
    deleteLink(index) {
      if (this.stamentId && this.tableLinkList.length === 1) {
        const id = Number(this.stamentId);
        this.$modal.show(DeleteLastLinkModal, {
          id
        },
        {
          width: 476,
          height: 'auto',
          adaptive: true,
          resizable: false,
          clickToClose: false
        }, {
          'before-open': this.beforeOpenModal,
          'before-close': this.beforeCloseModal
        });
        return;
      }
      this.tableLinkList.splice(index, 1);
      this.$emit('updatingData', this.$props);
    }
  }
};
